<div class="form-box">
  <div class="row">
    <ng-container *ngIf="isLoadingData">Loading...please wait...</ng-container>
    <ng-container *ngIf="!isLoadingData && !dataLoadedOk">Failed to load banks. Please click 'Back' to try again or
      choose a different payment option.</ng-container>
  </div>

  <ng-container>
    <div *ngIf="dataLoadedOk">
      <form [formGroup]="searchForm">
          <div class="row form-group">
            <div class="col-6 pl-0">
              <mat-form-field>
                <mat-select formControlName="searchCountry" placeholder="Country">
                  <mat-option value="">All</mat-option>
                  <mat-option *ngFor="let country of countries" [value]="country?.code">
                    <span>{{ country?.name }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-6 pr-0">
              <mat-form-field>
                <input matInput formControlName="searchBankName" type="text" placeholder="Bank name"
                  (keydown)="onSearchServiceProviderNameKeypress($event)" />
              </mat-form-field>
            </div>
          </div>
      </form>

      <div class="row form-group">
        <button class="btn btn-block btn-lg btn-greengo" (click)="buttonClicked('2')" npFocusOutClicked>Search</button>
      </div>

      <div class="row form-group no-result-found" *ngIf="banksInfo?.banks.length === 0">
        No banks found
      </div>

      <div *ngIf="banksInfo?.banks.length > 0">
        <div class="row text-note">
            <strong>Please select your online banking service...</strong>
        </div>

        <div class="row mb-3">
          <mat-list class="w-100">
            <mat-list-item class="row" [ngClass]="{'selectedItem': bank.id === bankSelectedId}"
              *ngFor="let bank of banksInfo?.banks" (click)="bankSelected(bank.id, bank.displayName, bank.countryCode)">
              <div class="col-3">
                <img src="{{ bank.fullLogoUrl }}" onerror="this.style.display='none'" alt="">
              </div>
              <div class="col-9">
                <div matLine>
                  <p class="bank-name">{{ bank.displayName }}</p>
                </div>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
      </div>

      <div class="row justify-content-center">
        <np-pagination 
          (changePage)="onChangePage($event)" 
          [totalItems]="totalItems"
          [showTotalItems]="false" 
          [pageSize]="pageSize">
        </np-pagination>
      </div>

      <div *ngIf="bankSelectedDisplayName" class="row">
        <p class="text-note mb-3">You will be redirected to
          <span class="text-fw-700">'{{ this.bankSelectedDisplayName }}'</span> when you click
          <span class="text-fw-700">'Next'</span>
        </p>
      </div>
    </div>

    <div *ngIf="!isLoadingData" class="row mt-3">
      <div class="col-6 pl-0">
        <button class="btn btn-lg btn-block btn-greengo-o" (click)="buttonClicked('-1')">
          Back
        </button>
      </div>

      <div *ngIf="dataLoadedOk" class="col-6 pr-0">
        <button class="btn btn-lg btn-block" [ngClass]="{
                  'btn-greengo': bankSelectedId,
                  'btn-inactive': !bankSelectedId
                }" (click)="buttonClicked('1')">
          Next
        </button>
      </div>
    </div>
  </ng-container>
</div>
